<template>
    <div class="ah-audit-flow-steps">
        <span class="step still">申請</span>
        <span v-for="step in visiableSteps" :key="step.sno" :class="{ step: true, editable: step.rolE_TYP != 3 }">
            {{ getStepName(step.menU_UNT) }}
        </span>
        <!-- <el-steps :active="visiableSteps.length+1">
            <el-step title="申請"></el-step>
            <el-step v-for="step in visiableSteps" :key="step.sno" :title="getStepName(step.menU_UNT)">
            </el-step>
        </el-steps> -->
    </div>
</template>
<script>
export default {
    name: 'audit-flow-steps',
    props: ['steps'],
    computed: {
        visiableSteps() {
            return this.steps.filter((x) => x.rolE_TYP != 0);
        },
    },
    methods: {
        getStepName(menu_nut) {
            if (menu_nut == 'A02') return '填寫付款明細';
            if (menu_nut == 'A03') return '確認付款';
            if (menu_nut == 'B02') return '開立';
            if (menu_nut == 'B03') return '入帳';
            return menu_nut;
        },
    },
};
</script>
<style lang="scss">
.ah-audit-flow-steps {
    .step {
        position: relative;
        display: inline-block;
        background-color: #eceef9;
        margin-left: 13px;
        margin-bottom: 5px;
        height: 46px;
        line-height: 46px;
        padding: 0 10px;
        color: #000;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;

        &:first-child {
            margin-left: 0;
        }

        &:before {
            position: absolute;
            content: "";
            display: block;
            top: 0px;
            right: -10px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 23px 0 23px 10px;
            border-color: transparent transparent transparent #eceef9;
        }

        &.still {
            background-color: #ddd;
            color: #666;

            &:before {
                border-color: transparent transparent transparent #ddd;
            }
        }

        &.editable {
            background-color: #3d53c6;
            height: 46px;
            line-height: 45px;
            font-weight: bold;
            color: #fff;

            &:before {
                border-width: 23px 0 23px 10px;
                border-color: transparent transparent transparent #3d53c6;
            }

            .el-select {
                width: 120px;
                margin-right: 10px;
            }

            .del-btn {
                position: absolute;
                display: inline-block;
                background-color: #000;
                width: 16px;
                height: 16px;
                top: 15px;
                right: -1px;
                line-height: 20px;
                border-radius: 10px;
                color: #fff;
                cursor: pointer;

                &:before {
                    position: absolute;
                    content: "";
                    top: 8px;
                    left: 3px;
                    width: 9px;
                    height: 1px;
                    background-color: #fff;
                    transform: rotate(-45deg);
                }

                &:after {
                    position: absolute;
                    content: "";
                    top: 8px;
                    left: 3px;
                    width: 9px;
                    height: 1px;
                    background-color: #fff;
                    transform: rotate(45deg);
                }

                &:hover {
                    background-color: red;

                    &:before,
                    &:after {
                    }
                }
            }
        }
    }

    .add-btn {
        margin-left: 13px;
        margin-right: 6px;
        width: 25px;
        padding: 9px 0;
        text-align: center;
    }
}
</style>
